"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const luxon_1 = require("luxon");
const classnames_1 = __importDefault(require("classnames"));
const uuid_1 = require("uuid");
const react_helmet_1 = require("react-helmet");
const query_string_1 = __importDefault(require("query-string"));
const mui_1 = require("tss-react/mui");
const immutable_1 = require("immutable");
const react_use_1 = require("react-use");
const AppBar_1 = __importDefault(require("@mui/material/AppBar"));
const Toolbar_1 = __importDefault(require("@mui/material/Toolbar"));
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const ListItemText_1 = __importDefault(require("@mui/material/ListItemText"));
const ListRounded_1 = __importDefault(require("@mui/icons-material/ListRounded"));
const CalendarTodayRounded_1 = __importDefault(require("@mui/icons-material/CalendarTodayRounded"));
const ProjectedBalances_1 = __importDefault(require("components/ProjectedBalances"));
const TransactionCalendar_1 = __importDefault(require("components/TransactionCalendar"));
const index_1 = __importDefault(require("components/TransactionRegister/index"));
const core_1 = require("companion-app-components/utils/core");
const securities_1 = require("companion-app-components/flux/securities");
const accounts_1 = require("companion-app-components/flux/accounts");
const accountGroupsSelectors_1 = require("companion-app-components/flux/account-groups/accountGroupsSelectors");
const Dump_1 = __importDefault(require("components/Dump"));
const UIState_1 = __importDefault(require("components/UIState"));
const ErrorBoundary_1 = __importDefault(require("components/ErrorBoundary"));
const withRouterLegacy_1 = __importDefault(require("components/withRouterLegacy"));
const BalanceSelectMenu_1 = __importDefault(require("components/BalanceSelectMenu"));
const AmountField_1 = __importDefault(require("components/QuickenControls/AmountField"));
const useQPreferences_1 = __importDefault(require("components/QPreferences/useQPreferences"));
const compose_1 = __importDefault(require("utils/compose"));
const accounts_svg_1 = __importDefault(require("assets/nav-menu/accounts.svg"));
const RegPrefsModal_1 = __importDefault(require("./RegPrefsModal"));
const HeaderTitleLeft_1 = __importDefault(require("./HeaderTitleLeft"));
const styles_1 = require("./styles");
const utils_1 = require("./utils");
const useSelectOrDispatch_1 = require("./useSelectOrDispatch");
const log = (0, core_1.getLogger)('containers/Transactions/index.tsx');
const TxUIState = (0, immutable_1.Record)({
    selectedAccountNodeId: 'all',
    firstTxnId: null,
    txnsPerPage: 10,
    showRegPrefs: false,
    location: null,
    calendarYear: null,
    calendarMonth: null,
    showCalendarUI: false,
});
const uiStateConfig = {
    name: () => 'TransactionsPage:',
    state: (props) => {
        // @ts-expect-error: Types of property 'selectedAccountNodeId' are incompatible.
        const ret = new TxUIState((0, utils_1.makeLocationObject)(props.router.location));
        log.log('INIT TX PAGE STATE WITH ->', props.router.location, props, ret);
        return ret;
    },
    persist: true,
};
const REGISTER_WRAPPER_NAME = 'registerWrapper_TxPage';
const useStyles = (0, mui_1.makeStyles)()(styles_1.styles);
const Transactions = (props) => {
    var _a, _b, _c;
    const { uiState, setUIState, router, history, } = props;
    const { classes, theme } = useStyles();
    const [monthsToView, setMonthsToView] = (0, react_1.useState)(12);
    const [, updateState] = (0, react_1.useState)({});
    const forceUpdate = (0, react_1.useCallback)(() => updateState({}), []);
    const isEntityShareEnableUser = (0, react_redux_1.useSelector)(accountGroupsSelectors_1.isEntityShareUser);
    const { documents, categories, accountNode, accountsById, calendarList, updateAccount, accountNodesById, projectedBalances, transactionCalendar, hideLoanTransactions, investmentTransactionsEnabled, hideConnectedLoanTransactions, hasWriteAccess, } = (0, useSelectOrDispatch_1.useData)(props);
    const regRef = (0, react_1.useRef)(null);
    const guidRef = (0, react_1.useRef)((0, uuid_1.v4)());
    const startTimeRef = (0, react_1.useRef)(luxon_1.DateTime.local());
    const widthBeforeResizeRef = (0, react_1.useRef)(null);
    const prevAccountNodesByIdRef = (0, react_1.useRef)(accountNodesById);
    const resizeTimeoutRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        core_1.tracker.track(core_1.tracker.events.txnRegActivity, {
            state: 'started',
            sessionId: guidRef.current,
        });
    }, []);
    const handleAccountNodeSelect = (node) => {
        if (typeof node === 'string') { // node id came from query parameter
            if (router.location.search !== uiState.location.search) {
                setUIState((0, utils_1.makeLocationObject)(router.location));
            }
            else {
                setUIState({ selectedAccountNodeId: node });
            }
        }
        else {
            router.navigate(`${node.routeTo}?displayNode=${node.id}`, { replace: true });
        }
    };
    const handleResize = () => {
        const isWidthChanged = window.innerWidth !== widthBeforeResizeRef.current;
        widthBeforeResizeRef.current = null;
        if (!isWidthChanged) {
            return;
        }
        forceUpdate();
    };
    const resizeThrottler = () => {
        if (resizeTimeoutRef.current) {
            clearTimeout(resizeTimeoutRef.current);
        }
        resizeTimeoutRef.current = setTimeout(handleResize, 66);
        if (widthBeforeResizeRef.current === null) {
            widthBeforeResizeRef.current = window.innerWidth;
        }
    };
    const addListeners = () => {
        window.addEventListener('resize', resizeThrottler);
    };
    const removeListeners = () => {
        window.removeEventListener('resize', resizeThrottler);
    };
    (0, react_use_1.useUnmount)(() => {
        const timeSpent = luxon_1.DateTime.local().diff(startTimeRef.current).as('seconds');
        core_1.tracker.track(core_1.tracker.events.txnRegActivity, {
            state: 'complete',
            sessionId: guidRef.current,
            timeSpent,
        });
        removeListeners();
    });
    (0, react_use_1.useMount)(() => {
        const query = query_string_1.default.parse(router.location.search);
        if (query.displayNode) {
            handleAccountNodeSelect(query.displayNode);
        }
        addListeners();
        setTimeout(() => {
            if (uiState.firstTxnId && regRef.current) {
                log.log('SETTING TRANSACTION TO ', uiState.firstTxnId);
                // @ts-expect-error: Property 'scrollToTransaction' does not exist on type 'never'.
                regRef.current.scrollToTransaction(uiState.firstTxnId);
                setUIState({ firstTxnId: null });
            }
        }, 100);
    });
    (0, react_1.useEffect)(() => {
        const prevAccountNodesById = prevAccountNodesByIdRef.current;
        if (prevAccountNodesById !== accountNodesById) {
            if (uiState.selectedAccountNodeId && !accountNode) {
                router.navigate('/transactions?displayNode=all', { replace: true });
            }
        }
        prevAccountNodesByIdRef.current = accountNodesById;
    }, [accountNodesById, accountNode, uiState.selectedAccountNodeId, router]);
    (0, react_1.useEffect)(() => {
        widthBeforeResizeRef.current = null;
        if (uiState.firstTxnId && regRef.current) {
            log.log('SETTING TRANSACTION TO ', uiState.firstTxnId);
            // @ts-expect-error: Property 'scrollToTransaction' does not exist on type 'never'.
            regRef.current.scrollToTransaction(uiState.firstTxnId);
            setUIState({ firstTxnId: null });
        }
        if (router.location.search !== uiState.location.search) {
            setUIState((0, utils_1.makeLocationObject)(router.location));
        }
    }, [uiState.firstTxnId, router, uiState.location.search, setUIState]);
    const { setDatasetPreference, datasetPreferences, } = (0, useQPreferences_1.default)();
    const resetRegFocus = () => {
        var _a;
        if (regRef.current) {
            // @ts-expect-error: Property 'resetFocus' does not exist on type 'never'.
            (_a = regRef.current) === null || _a === void 0 ? void 0 : _a.resetFocus();
        }
    };
    const closeAndSavePrefs = () => {
        setUIState({ showRegPrefs: false });
        resetRegFocus();
    };
    const updateAccountName = (value) => {
        if (!accountNode)
            return;
        // if name unchanged, return
        if (value === accountNode.displayLabel)
            return;
        // call update account action after making object of account with mkUpdateAccount
        updateAccount(accounts_1.accountsTypes.mkUpdateAccount(accountNode.account.type, { id: accountNode.id, name: value }));
    };
    const navigateTo = (accountId, txnId) => {
        log.log('NAVIGATE TO ', accountId, txnId);
        const node = accountNodesById.get(accountId);
        setUIState({ firstTxnId: txnId, selectedAccountNodeId: node === null || node === void 0 ? void 0 : node.id });
        router.navigate(`/transactions?displayNode=${node === null || node === void 0 ? void 0 : node.id}&txnId=${txnId}`, { replace: true });
    };
    const navigateToCalendar = (showCalendarUI) => {
        log.log('NAVIGATE TO CALENDAR UI');
        core_1.tracker.track(core_1.tracker.events.txnTopMenuToggle, {
            view: showCalendarUI ? 'View Transaction Calendar' : 'View Transaction Register',
        });
        setUIState({ showCalendarUI });
        const query = query_string_1.default.parse(router.location.search);
        if (showCalendarUI && query.txnId) {
            router.navigate(`/transactions?displayNode=${query.displayNode}`, { replace: true });
        }
    };
    const setCalendarDate = (year, month) => {
        setUIState({ calendarYear: year, calendarMonth: month });
    };
    const regFieldsOrderChange = (newList) => {
        setDatasetPreference({ transactionRegister: { regFieldsSort: { cashFlow: newList.toArray() } } });
        core_1.tracker.track(core_1.tracker.events.txnPrefs, {
            type: 'regFieldsOrder',
            state: 'true',
        });
    };
    const onSortChange = (sortField, sortOrder) => {
        if (accountNode) {
            // write the new sortBy and sortOrder to prefs
            setDatasetPreference({
                accountNodePrefs: { [accountNode.id]: { sortBy: sortField, sortOrder } },
            });
        }
    };
    const openTransactionPreferences = () => {
        setUIState({ showRegPrefs: true });
    };
    const { transactionRegister: regPrefs, accountBarBalanceType, accountBarShowCents, upcomingOpen, projectedOpen } = datasetPreferences, otherPrefs = __rest(datasetPreferences, ["transactionRegister", "accountBarBalanceType", "accountBarShowCents", "upcomingOpen", "projectedOpen"]);
    const balanceKey = accountBarBalanceType;
    const isLeaf = Boolean(accountNode && !accountNode.children);
    const displayColumnsKey = (0, utils_1.getDisplayColumnsKey)(accountNode, regPrefs.regFieldsSort);
    const { balance, balanceRecord, balanceText } = (0, utils_1.getBalanceData)(accountNode, balanceKey);
    const { isEditableTitle, isLoanPage, subtitle, title, } = (0, utils_1.getHeaderData)(accountNode, isLeaf, accountsById, hideLoanTransactions, hideConnectedLoanTransactions);
    const loanStateContainer = (<div className={classes.zeroStateContainer}>
      <img alt="No Transactions" src={accounts_svg_1.default} className={classes.zeroStateImg}/>
      <br />
      <div className={classes.zeroStateTextBody}>
        {'You may view your balances for Loan Accounts, but loan transactions are not currently supported'}
      </div>
    </div>);
    const { showUpcoming, showGraph } = (0, utils_1.getUpcomingState)(projectedBalances, accountNode, calendarList);
    const firstAccount = (0, utils_1.getFirstAccount)(accountNode, accountsById);
    const isInvestment = investmentTransactionsEnabled && (firstAccount === null || firstAccount === void 0 ? void 0 : firstAccount.type) === 'INVESTMENT';
    const calendarDate = (0, immutable_1.Map)({ calendarYear: uiState.calendarYear, calendarMonth: uiState.calendarMonth });
    const noNew = !hasWriteAccess;
    return (<ErrorBoundary_1.default className={classes.root}>
      <react_helmet_1.Helmet>
        <title>Transactions</title>
      </react_helmet_1.Helmet>

      {uiState.showRegPrefs &&
            <RegPrefsModal_1.default onClose={closeAndSavePrefs}/>}

      <div className={classes.appFrame}>
        <AppBar_1.default id="txpage-appbar" className={(0, classnames_1.default)(classes.appBar)}>
          <Toolbar_1.default classes={{ root: classes.toolBar }} disableGutters={false}>
            <div className={classes.headerWrapper}>

              <HeaderTitleLeft_1.default onTitleChange={(value) => updateAccountName(value)} title={title} isEditableTitle={isEditableTitle} monthsToView={monthsToView} onViewChange={(e) => setMonthsToView(e.target.value)}/>
              <Typography_1.default className={(0, classnames_1.default)(classes.leftSideContent, 'sub')} noWrap>
                {subtitle}
              </Typography_1.default>
            </div>
            {transactionCalendar &&
            <div className={classes.viewButtons}>
                <IconButton_1.default onClick={() => navigateToCalendar(false)} size="large">
                  <ListRounded_1.default style={{ color: uiState.showCalendarUI ? null : theme.palette.text.strong }}/>
                </IconButton_1.default>
                <IconButton_1.default onClick={() => navigateToCalendar(true)} size="large">
                  <CalendarTodayRounded_1.default style={{ color: uiState.showCalendarUI ? theme.palette.text.strong : null }}/>
                </IconButton_1.default>
              </div>}

            {<div className={classes.rightSideContent}>
                <div className={classes.balanceWrapper}>
                  <Dump_1.default obj={[balanceRecord, accountNode]}/>
                  <ListItemText_1.default primary={<AmountField_1.default 
            // @ts-expect-error: Type 'string' is not assignable to type 'number'.
            value={balance} className={(0, classnames_1.default)(classes.inlineText, isLeaf ? 'with-icon' : '')} 
            // @ts-expect-error: Operator '<' cannot be applied to types 'string' and 'number'.
            color={`${balance < 0 ? 'red' : ''}`} currencySymbol={(_a = accountNode === null || accountNode === void 0 ? void 0 : accountNode.currency) !== null && _a !== void 0 ? _a : 'USD'} id="balance-top-right" omitCents={!accountBarShowCents}/>}/>

                  <Typography_1.default id="balance-type" className={classes.inlineTextBalance} color="inherit" noWrap>
                    {balanceText}
                  </Typography_1.default>

                  <BalanceSelectMenu_1.default classes={{ balanceMenu: classes.balanceMenu, iconColor: classes.settingsIcon }}/>
                </div>

              </div>}
          </Toolbar_1.default>
        </AppBar_1.default>

        <main id="txpage-main" className={(0, classnames_1.default)(classes.content)}>
          {uiState.showCalendarUI &&
            <div id={`${REGISTER_WRAPPER_NAME}-cal`}>
              {accountNode &&
                    <TransactionCalendar_1.default navFn={(txn) => {
                            navigateToCalendar(false);
                            if (txn) {
                                navigateTo(txn.accountId, txn.id);
                            }
                        }} month={uiState.calendarMonth} year={uiState.calendarYear} setDate={setCalendarDate} accountIds={accountNode.allAccountIds}/>}
            </div>}

          {!uiState.showCalendarUI &&
            <>
              {accountNode && !isLoanPage && !isInvestment && showUpcoming && !isEntityShareEnableUser &&
                    <ProjectedBalances_1.default wrapperId={REGISTER_WRAPPER_NAME} 
                    // @ts-expect-error: allAccountIds is List<string> at runtime; component expects List<number>
                    accountIds={accountNode.allAccountIds} open={projectedOpen} showGraph={showGraph} calendarList={calendarList} showCollapsible={false} clickableTooltip={false}/>}

              {accountNode && !isLoanPage && !isInvestment &&
                    <div id={REGISTER_WRAPPER_NAME} className={classes.register}>
                  <index_1.default ref={regRef} 
                    // @ts-expect-error: allAccountIds is List<string> at runtime; component expects List<number>
                    accountIds={accountNode.allAccountIds} categories={categories} documents={documents} doubleAmounts={regPrefs.doubleAmounts} editDownloaded={regPrefs.editDownloaded} deleteDownloaded={regPrefs.deleteDownloaded} splitsInDialog={regPrefs.splitsInDialog} autoSave={regPrefs.autoSave} registerComfort={regPrefs.registerComfort} autoSearch={regPrefs.autoSearch} wrapText={regPrefs.wrapText} longCats={regPrefs.longCats} continuousCreate={regPrefs.continuousCreate} showCurrencySymbol={regPrefs.showCurrencySymbol} currencySymbol={otherPrefs.currencySymbol} regFieldsOrder={regPrefs.regFieldsSort[displayColumnsKey] || null} showAccountColors={regPrefs.showAccountColors} regFieldsOrderChange={regFieldsOrderChange} onSortChange={onSortChange} navFn={navigateTo} showControls txId={null} // {uiState.showRegisterTxId}
                     wrapperId={REGISTER_WRAPPER_NAME} history={history} openPrefs={openTransactionPreferences} accountNodeId={(_b = accountNode.id) !== null && _b !== void 0 ? _b : ''} adapt={(upcomingOpen ? 2 : 0) + (projectedOpen ? 1 : 0)} reminderSetting={0} accountsById={accountsById} showDebtErrorMessage={uiState.get('selectedAccountNodeId') === securities_1.securitiesTypes.SecurityTypeEnum.DEBT} earliestTransactionDate={luxon_1.DateTime.now().minus({ months: monthsToView }).toFormat('yyyy-MM-dd')} setCalendarDate={setCalendarDate} calendarDate={calendarDate} noNew={noNew}/>
                </div>}

              {isLoanPage && loanStateContainer}

              {isInvestment && (<div id={REGISTER_WRAPPER_NAME} className={classes.register}>
                  <index_1.default ref={regRef} 
                // @ts-expect-error: allAccountIds is List<string> at runtime; component expects List<number>
                accountIds={accountNode === null || accountNode === void 0 ? void 0 : accountNode.allAccountIds} categories={categories} documents={documents} doubleAmounts={regPrefs.doubleAmounts} editDownloaded={regPrefs.editDownloaded} deleteDownloaded={regPrefs.deleteDownloaded} splitsInDialog={regPrefs.splitsInDialog} autoSave={regPrefs.autoSave} registerComfort={regPrefs.registerComfort} autoSearch={regPrefs.autoSearch} wrapText={regPrefs.wrapText} longCats={regPrefs.longCats} continuousCreate={regPrefs.continuousCreate} showCurrencySymbol={regPrefs.showCurrencySymbol} currencySymbol={otherPrefs.currencySymbol} regFieldsOrder={regPrefs.regFieldsSort[displayColumnsKey] || null} showAccountColors={regPrefs.showAccountColors} regFieldsOrderChange={regFieldsOrderChange} onSortChange={onSortChange} navFn={navigateTo} showControls txId={null} wrapperId={REGISTER_WRAPPER_NAME} history={history} openPrefs={openTransactionPreferences} accountNodeId={(_c = accountNode === null || accountNode === void 0 ? void 0 : accountNode.id) !== null && _c !== void 0 ? _c : ''} adapt={(upcomingOpen ? 2 : 0) + (projectedOpen ? 1 : 0)} reminderSetting={0} accountsById={accountsById} showDebtErrorMessage={uiState.get('selectedAccountNodeId') === securities_1.securitiesTypes.SecurityTypeEnum.DEBT} earliestTransactionDate={luxon_1.DateTime.now().minus({ months: monthsToView }).toFormat('yyyy-MM-dd')} setCalendarDate={setCalendarDate} calendarDate={calendarDate} noNew={noNew}/>
                </div>)}
            </>}
        </main>
      </div>
    </ErrorBoundary_1.default>);
};
exports.default = (0, compose_1.default)(withRouterLegacy_1.default, (0, UIState_1.default)(uiStateConfig))(Transactions);
